<template>
    <jet-authentication-card :standalone="standalone">
        <Head v-if="standalone" title="Login" />

        <div v-if="status" class="mb-4 text-center text-green-600 text-lg font-medium">
            {{ status }}
        </div>

        <template #logo>
            <jet-authentication-card-header>
                <a href="/" title="Throbo" class="dark:hidden"><img src="/images/logo/throbo-logo.svg" alt="Throbo Logo" /></a>
                <template #title> Sign In To Your Account </template>
                <template #link>
                    <Link :href="route('register')" class="hover:text-indigo-700 text-indigo-900 dark:text-slate-300 dark:hover:text-slate-100 font-medium dark:underline"> create your account </Link>
                </template>
            </jet-authentication-card-header>
        </template>

        <!--<social-login></social-login>-->

        <!--<div class="relative">-->
        <!--    <div class="absolute inset-0 flex items-center" aria-hidden="true">-->
        <!--        <div class="w-full border-t border-gray-300"></div>-->
        <!--    </div>-->
        <!--    <div class="relative flex justify-center">-->
        <!--        <span class="px-2 text-gray-500 text-sm bg-gray-100"> OR </span>-->
        <!--    </div>-->
        <!--</div>-->

        <jet-validation-errors class="mb-4" />

        <form @submit.prevent="submit">
            <div class="text-gray-600 dark:text-slate-300 focus-within:text-indigo-700 dark:focus-within:text-slate-100">
                <label class="block text-sm font-medium" for="email">Email Address</label>
                <jet-input id="email" type="text" class="block mt-1 w-full" v-model="form.email" required autofocus />
            </div>

            <div class="mt-4 text-gray-600 dark:text-slate-300 focus-within:text-indigo-700 dark:focus-within:text-slate-100">
                <label class="block text-sm font-medium" for="password">Password</label>
                <jet-input id="password" name="password" type="password" class="block mt-1 w-full" v-model="form.password" required autocomplete="current-password" />
            </div>

            <div class="block mt-4">
                <label class="flex items-center cursor-pointer">
                    <jet-checkbox name="remember" v-model="form.remember" />
                    <span class="ml-2 text-gray-600 dark:text-slate-300 text-sm">Remember me</span>
                </label>
            </div>

            <div class="flex flex-col items-center justify-end mt-4">
                <jet-button class="justify-center mb-2 w-full text-base disabled:bg-brand-300 bg-brand-500 hover:bg-brand-700 active:bg-brand-700 ring-brand-700" :processing="form.processing"> Login </jet-button>
            </div>
        </form>

        <div class="px-2 text-center sm:px-10">
            <Link v-if="canResetPassword" :href="route('password.request')" class="hover:text-gray-500 text-gray-600 dark:text-slate-300 dark:hover:text-slate-400 text-sm leading-5"> Forgot your password? </Link>
        </div>

        <!--        <div class="flex">-->
        <!--            <hr class="my-6 flex-grow">-->
        <!--            <span class="flex-grow-0 px-4 place-self-center text-gray-500">OR</span>-->
        <!--            <hr class="my-6 flex-grow">-->
        <!--        </div>-->
        <!--        <div class="flex mt-2 group">-->
        <!--            <div class=" border-b border-gray-600 group-hover:border-gray-900">-->

        <!--            <Link :href="route('register')" class="text-base text-gray-600 group-hover:text-gray-900">-->
        <!--                Create Your Account-->
        <!--            </Link>-->
        <!--            </div>-->
        <!--        </div>-->
    </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard"
import JetAuthenticationCardHeader from "@/Jetstream/AuthenticationCardHeader"
import JetButton from "@/Jetstream/Button"
import JetInput from "@/Jetstream/Input"
import JetCheckbox from "@/Jetstream/Checkbox"
import JetLabel from "@/Jetstream/Label"
import JetValidationErrors from "@/Jetstream/ValidationErrors"
import SocialLogin from "@/Pages/Auth/SocialLogin"

export default {
    components: {
        JetAuthenticationCard,
        JetAuthenticationCardHeader,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        SocialLogin,
    },

    props: {
        canResetPassword: Boolean,
        status: String,
        standalone: {
            default: true,
            type: Boolean,
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                email: "",
                password: "",
                remember: false,
            }),
        }
    },

    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    remember: this.form.remember ? "on" : "",
                }))
                .post(this.route("login"), {
                    onFinish: () => this.form.reset("password"),
                })
        },
    },
}
</script>
